module.exports = __webpack_public_path__ + "media/event-access/webinar@3x-92899c42.png";